import type { TranslateFunction } from "ra-core";

import type { LabeledValue } from "../types";

/**
 * Display label of a stored choice value (a sector, a deal category, a task
 * type...) from the configured choices, never the raw slug. The label goes
 * through `translate` when given (a label may be an i18n key; a plain label
 * is returned as is). A value missing from the choices (removed in Settings)
 * is shown as stored rather than hidden.
 */
export const getChoiceLabel = (
  choices: readonly LabeledValue[],
  value: string | null | undefined,
  translate?: TranslateFunction,
): string | undefined => {
  if (!value) return undefined;
  const label = choices.find((choice) => choice.value === value)?.label;
  if (!label) return value;
  return translate ? translate(label, { _: label }) : label;
};
